import React, { useImperativeHandle, useState } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

function BankTransfer(props) {
  const {
    accountNumber,
    setAccountNumber,
    routingNumber,
    setRoutingNumber,
    accountType,
    setAccountType,
    finixBankRef,
  } = props;

  const [errors, setErrors] = useState([]);

  useImperativeHandle(finixBankRef, () => ({
    checkValidity: () => {
      const errors = [];
      if (accountNumber == "") {
        errors.push("ACCOUNT_NUMBER_ERROR");
      }
      if (routingNumber.length !== 9) {
        errors.push("ROUTING_NUMBER_ERROR");
      }
      setErrors(errors);
      return errors;
    },
  }));

  // Helper function to get error message for each field
  const getErrorMessage = (errorType) => {
    switch (errorType) {
      case "ACCOUNT_NUMBER_ERROR":
        return "Please enter a valid account number";
      case "ROUTING_NUMBER_ERROR":
        return "Please enter a valid 9-digit routing number";
      default:
        return "";
    }
  };

  return (
    <div className="space-y-3">
      <div className="space-y-0.0">
        <Label
          htmlFor="account-number"
          className="text-sm font-medium text-ink-muted"
        >
          Account Number
        </Label>
        <Input
          value={accountNumber}
          onChange={(e) => setAccountNumber(e.target.value.replace(/\D/g, ""))}
          type="text"
          id="account-number"
          onFocus={() => {
            // remove account number error if it exists
            setErrors((prev) =>
              prev.filter((error) => error !== "ACCOUNT_NUMBER_ERROR")
            );
          }}
          className={`h-7 w-full border-edge bg-paper-muted focus:border-edge focus:ring-edge ${
            errors.includes("ACCOUNT_NUMBER_ERROR")
              ? "border-red-500"
              : "border-edge"
          }`}
        />
        {errors.includes("ACCOUNT_NUMBER_ERROR") && (
          <p className="mt-1 text-xs text-red-500">
            {getErrorMessage("ACCOUNT_NUMBER_ERROR")}
          </p>
        )}
      </div>
      <div className="space-y-0.25">
        <Label
          htmlFor="routing-number"
          className="text-sm font-medium text-ink-muted"
        >
          Routing Number
        </Label>
        <Input
          value={routingNumber}
          onChange={(e) => setRoutingNumber(e.target.value.replace(/\D/g, ""))}
          type="text"
          id="routing-number"
          onFocus={() => {
            // remove routing number error if it exists
            setErrors((prev) =>
              prev.filter((error) => error !== "ROUTING_NUMBER_ERROR")
            );
          }}
          className={`h-7 w-full border-edge bg-paper-muted focus:border-edge focus:ring-edge ${
            errors.includes("ROUTING_NUMBER_ERROR")
              ? "border-red-500"
              : "border-edge"
          }`}
        />
        {errors.includes("ROUTING_NUMBER_ERROR") && (
          <p className="mt-1 text-xs text-red-500">
            {getErrorMessage("ROUTING_NUMBER_ERROR")}
          </p>
        )}
      </div>
      <div className="mt-1 grid grid-cols-2">
        <label className="inline-flex items-center">
          <input
            type="radio"
            className="form-radio h-4 w-4 cursor-pointer border-edge bg-paper-muted text-sage focus:ring-sage"
            name="checking"
            value="CHECKING"
            id="checking"
            checked={accountType === "CHECKING"}
            onChange={(e) => setAccountType("CHECKING")}
          />
          <span className="ml-1 text-base text-ink-secondary">
            Checking Account
          </span>
        </label>
        <label className="inline-flex items-center">
          <input
            type="radio"
            className="form-radio h-4 w-4 cursor-pointer border-edge bg-paper-muted text-sage focus:ring-sage"
            name="savings"
            value="SAVINGS"
            id="savings"
            checked={accountType === "SAVINGS"}
            onChange={(e) => setAccountType("SAVINGS")}
          />
          <span className="ml-1 text-base text-ink-secondary">Savings Account</span>
        </label>
      </div>
    </div>
  );
}

export default BankTransfer;
